import { useMemo } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';
import { GRAPHQL_TYPENAMES } from 'modules/graphql';

import { DEFAULT_JOURNEYS, USE_JOURNEYS_HOOK_QUERY } from './constants';
import { UseJourneysHookInputs, UseJourneysHookOutput, UseJourneysQueryData } from './types';
import { useJourneysVariables } from './useJourneysVariables';

export const useJourneys = ({ search }: UseJourneysHookInputs): UseJourneysHookOutput => {
  const variables = useJourneysVariables(search);
  const {
    data: { journeys: data } = {},
    error: didError,
    isLoading,
  } = useGraphql<UseJourneysQueryData>(USE_JOURNEYS_HOOK_QUERY, { variables });
  const journeys = useMemo(
    () =>
      data?.results
        .filter(({ __typename }) => __typename === GRAPHQL_TYPENAMES.JOURNEY)
        .map(({ id, name }) => ({ id, name })) ?? DEFAULT_JOURNEYS,
    [data?.results],
  );
  return { journeys, didError, isLoading };
};
